export default defineNuxtRouteMiddleware(async (to) => {
  if (!process.client) return

  const rawSessionVoucher = to?.query?.c?.toString()

  const sanitizeVoucherCode = (code: string | undefined) => {
    if (!code) return undefined
    return code.replace(/[^a-zA-Z0-9_-]/g, '').toUpperCase()
  }

  const sessionVoucher = sanitizeVoucherCode(rawSessionVoucher?.toString())
  const store = useSessionVoucherStore()
  const { addNotification } = useNotificationsStore()
  const { t } = useNuxtApp().$i18n

  const hasRun = useState('voucherValidated', () => false)
  if (hasRun.value) return

  const partnerData = useSubdomain().value?.subdomainData
    ? (await useSubdomainData()).data.value
    : undefined

  const supplierId = supplierGetters.getId(partnerData)

  const voucherCode = sessionVoucher || store.voucherCode
  if (!voucherCode) return

  try {
    await store.validateVoucher(voucherCode, supplierId || undefined)

    store.showVoucherNotification()

    hasRun.value = true
  } catch (e: any) {
    const message = e?.data?.message || t('cart.sessionVoucher.errorMessage')
    addNotification({ type: 'ERROR', message, showIcon: true })
  }
})
